export default function Footer() {
    return (
        <footer className="border-t border-[#1c1c1c] px-5 py-10" data-testid="footer">
            <div className="mx-auto max-w-6xl">
                <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
                    <p className="font-display text-xs font-bold tracking-tight text-[#bbb]">
                        © 2026 BIZECOM<span className="text-grad">ACADEMY</span>. Todos los derechos reservados.
                    </p>
                    <nav className="flex items-center gap-6">
                        <a href="#/privacidad" className="text-xs text-[#777] transition-colors hover:text-[#f5f5f5]" data-testid="footer-privacy-link">
                            Privacidad
                        </a>
                        <a href="#/terminos" className="text-xs text-[#777] transition-colors hover:text-[#f5f5f5]" data-testid="footer-terms-link">
                            Términos
                        </a>
                    </nav>
                </div>
                <p className="mt-8 max-w-3xl text-center text-[11px] leading-relaxed text-[#555] sm:mx-auto" data-testid="footer-disclaimer">
                    Los resultados mostrados son de alumnos reales. Los resultados individuales varían según esfuerzo, capital y
                    ejecución de cada persona. Este sitio no está afiliado a Meta Platforms, Inc.
                </p>
            </div>
        </footer>
    );
}
